import React from 'react'
import TransactionDetails from './TransactionDetails'
import ArrowLink from '../General/ArrowLink'
import ProgressSteps from '../General/ProgressSteps'
import Buttons from './Buttons'
import ImageCard from './ImageCard'
import InfoCard from './InfoCard'
import FloatingIcon from '../Detail/FloatingIcon'

function Gather() {
  return (
    <div>
      <ArrowLink/>
      <ProgressSteps completed={3}/>
      <TransactionDetails/>   
      <ImageCard/>  
      <InfoCard/> 
      <Buttons/>  
      <FloatingIcon/>
    </div>
  )
}

export default Gather